import { buildQueries, HTTP } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";

export function callApiLayDanhSachDonViCha(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.DON_VI.DANH_SACH_DON_VI_CHA}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiUpdateSetLock(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.put(`${ENDPOINT.DON_VI.CAP_NHAT_KHOA_CAN_BO}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachTheoDonViCha(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.DON_VI.DANH_SACH_DON_VI_CON_LAY_ID_THEO_CHA}?${buildQueries(
        payload
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachCanBoTrucThuoc(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.DON_VI.DANH_SACH_CAN_BO_TRUC_THUOC}?${buildQueries(payload)}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachCanBo(payload) {
  console.log(123123);
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.DON_VI.DANH_SACH_CAN_BO}?${buildQueries(payload)}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiTaoMoiDonVi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.DON_VI.TAO_DON_VI}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiSuaDonVi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.put(`${ENDPOINT.DON_VI.SUA_DON_VI}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiThemMoiCanBoTrucThuoc(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.DON_VI.THEM_CAN_BO_TRUC_THUOC}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiXoaCanBoTrucThuoc(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.DON_VI.XOA_CAN_BO}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiXoaDonVi(payload) {
  return HTTP({
    url: `${ENDPOINT.DON_VI.XOA_DON_VI}/${payload}`,
    method: "DELETE",
  });
}
export function callApiLayDanhSachDonViPhanTrang(payload) {
  return HTTP({
    url: ENDPOINT.DON_VI.SEARCH,
    method: "GET",
    params: payload
  });
}

export function callApiLayCayDonVi(payload) {
  return HTTP({
    url: ENDPOINT.DON_VI.TREE,
    method: "GET",
    params: payload
  });
}

export function callApiLayChiTietDonVi(payload) {
  return HTTP({
    url: ENDPOINT.DON_VI.CRUD,
    method: "GET",
    params: payload
  });
}
export function callApiTaoDonVi(payload) {
  return HTTP({
    url: ENDPOINT.DON_VI.CRUD,
    method: "POST",
    data: payload
  });
}

export function callApiCapNhatThuTu(payload) {
  return HTTP({
    url: ENDPOINT.DON_VI.ORDER,
    method: "PATCH",
    data: payload
  });
}

export function callApiLayDanhSachPhamVi(payload) {
  return HTTP({
    url: ENDPOINT.DON_VI.GET_PHAM_VI,
    method: "GET",
    params: payload
  });
}

export function callApiLayThuTuMacDinh(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.DON_VI.LAY_THU_TU_MAC_DINH}?${buildQueries(payload)}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}
